import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView } from "../../../../Component/style/common_style";
import { useNavigate } from "react-router-dom";

const CompleteModal = ({ visible, handleModal }: modalProps) => {
  const Navigate = useNavigate();
  const goHome = () => Navigate("/");

  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <Container style={visible ? {} : { display: "none" }}>
      <ModalBox onClick={stopPropagation}>
        <Title>입점 신청완료</Title>
        <ContentDiv>
          <div>입점 신청이 완료되었습니다.</div>
          <div>승인 검토 후 기재된 연락처 및 메일로 안내드리겠습니다.</div>
        </ContentDiv>
        <BtnDiv>
          <ApplyBtn onClick={goHome}>확인</ApplyBtn>
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default CompleteModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 90%;
  max-width: 24rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 2rem 1rem 1rem 1rem;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const ContentDiv = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  gap: 5px;
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border-radius: 8px;
  height: 44px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;
